import { useMemo } from 'react';
import { countSpcIssues } from '../../../shared/services/spc/countSpcIssues.ts';
import { spcCheckFull } from '../../../shared/services/spc/spcCheckFull.ts';
import { SpcOverridesMap, SpcTogglesMap } from '../../../shared/types/spc.ts';
import { Protocol, RecordWithProtocol } from '../../types/sharedTypeImpl.ts';


interface Props {
    protocol: Protocol | undefined;
    filteredRecords: RecordWithProtocol[] | null;
    spcTogglesMap: SpcTogglesMap | undefined;
    overrides: SpcOverridesMap;
}


export function useSpcResults({
    protocol,
    filteredRecords,
    spcTogglesMap,
    overrides,
}: Props) {

    const spcResults = useMemo(() => {
        if (!protocol || !filteredRecords) return null;
        return spcCheckFull(protocol, filteredRecords, overrides);
    }, [protocol, filteredRecords, overrides]);


    const issuesCount = useMemo(() => {
        if (!spcResults || !spcTogglesMap) return null;
        return countSpcIssues(spcResults, spcTogglesMap);
    }, [spcResults, spcTogglesMap]);


    return {
        spcResults,
        issuesCount,
    };
}
